import { IconType } from 'react-icons/lib';

const JobOpenIcon: React.FC<{ color?: string; height?: number; width?: number }> = ({
  color,
  height = 24,
  width = 24,
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1003_26739)">
      <path
        d="M12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.1562 15.0938V12.8438H8.90625C8.43867 12.8438 8.0625 12.4676 8.0625 12C8.0625 11.5324 8.43867 11.1562 8.90625 11.1562H11.1562V8.90625C11.1562 8.43867 11.5324 8.0625 12 8.0625C12.4676 8.0625 12.8438 8.43867 12.8438 8.90625V11.1562H15.0938C15.5613 11.1562 15.9375 11.5324 15.9375 12C15.9375 12.4676 15.5613 12.8438 15.0938 12.8438H12.8438V15.0938C12.8438 15.5613 12.4676 15.9375 12 15.9375C11.5324 15.9375 11.1562 15.5613 11.1562 15.0938Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1003_26739">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

const JobOpenedIcon: IconType = () => <JobOpenIcon color="currentColor" />;

export default JobOpenIcon;
export { JobOpenedIcon };
